<template src="./template.html"></template>

<script>
import { mapState } from 'vuex'
import _filter from 'lodash/filter'
import _sortBy from 'lodash/sortBy'
import moment from 'moment'

import Datepicker from 'vuejs-datepicker'
import inventoryService from 'api/inventory'
import INVENTORY_TYPES from 'constants/inventoryTypes'
import dateUtils from 'utils/dateUtils'

export default {
  name: 'select-pick-up-time',
  components: {
    Datepicker,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    pickUpType: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState({
      date: (state) => state.date.current,
      venue: (state) => state.venue.current,
    }),
    currentPickUpTimeTypeInventory() {
      return _filter(this.pickUpTimeInventory, {
        pickUpType: this.pickUpType,
      })
    },
    shouldLockDate() {
      return this.venue && this.venue.inventoryTimeframe <= 1
    },
    utcDate() {
      return this.date ? dateUtils.toUTCDateWithoutTime(this.date) : ''
    },
  },
  watch: {
    value(val) {
      this.innerValue = val
    },
  },
  data() {
    return {
      loading: false,
      innerValue: null,
      pickUpTimeInventory: null,
      datePickerDisabledOptions: {
        to: null,
        from: null,
      },
    }
  },
  methods: {
    onDatepickerSelected(newDate) {
      const date = dateUtils.toUTCMomentWithoutTime(newDate)

      this.$store.dispatch('setCurrentDate', date)

      this.pickUpTimeInventory = null

      this.updateValue(null)

      this.getPickUpTimeInventory().then(() => {
        return null
      })
    },
    onDatepickerOpened() {
      this.$emit('updated')
    },
    onDatepickerClosed() {
      this.$emit('updated')
    },
    getPickUpTimeInventory() {
      this.loading = true

      return inventoryService
        .listByVenueId(this.venue.id, {
          type: INVENTORY_TYPES.PICK_UP_TIME,
          pickUpType: this.pickUpType,
          dateStart: dateUtils.toUTCTimestampWithoutTime(this.date),
          dateEnd: dateUtils.toUTCTimestampWithoutTime(this.date),
        })
        .then((result) => {
          this.pickUpTimeInventory = _sortBy(result.data, 'pickUpStart')
          this.pickUpTimeInventory = _filter(this.pickUpTimeInventory, (inv) => inv.quantity > 0)

          this.loading = false
        })
    },
    updateValue(newVal) {
      this.innerValue = newVal

      this.update()
    },
    update() {
      const newVal = this.innerValue

      this.$emit('input', newVal)
      this.$emit('change', newVal)
    },
  },
  mounted() {
    this.innerValue = this.value

    const maxDate =
      this.venue && this.venue.inventoryTimeframe
        ? moment()
            .utc()
            .add(this.venue.inventoryTimeframe - 1, 'day')
        : null

    this.datePickerDisabledOptions.to = moment.utc().subtract(1, 'day').toDate()
    this.datePickerDisabledOptions.from = maxDate ? maxDate.toDate() : null

    this.getPickUpTimeInventory().then(() => {
      return null
    })
  },
}
</script>



// WEBPACK FOOTER //
// src/components/SelectPickUpTime/index.vue